var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
  'text-box': !this.clearClass
}},[_c('span',{staticClass:"edit-text-init",class:{
    'edit-text': !this.clearClass,
  },attrs:{"contenteditable":"true"},on:{"blur":_vm.blur,"paste":_vm.paste}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/EditTextBox/EditTextBox.vue